import React, { useState } from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import { Modal as PopupModal } from "@cars24/turbo-web/lib/modal";
import { Heading } from "@cars24/turbo-web/lib/heading";
import { BodyText } from "@cars24/turbo-web/lib/body-text";
import { useTokens } from "@cars24/turbo-web/lib/theme-provider";
import { NUMBER } from "../../../constants/app-constants";
import RtoVehInfoQuestionList from "../../shared/rto-veh-info-question-list";
import Modal from "../../shared/modal";
import loadable from "@loadable/component";
const Lottie = loadable(() => import("react-lottie"), { ssr: true });
import ThinkingCap from "./thinking-cap.json";
import LazyImage from "../../shared/lazy-image";
import { yieldToMain } from "../../../utils/helpers/yield-to-main";
import { sendCustomGaEvents } from "../../../tracking";
import { PAGE_TYPES } from "../../../constants/rto-constants";
// import AdsComponent from "../../shared/ads";
// import { appUrl } from "../../../constants/url-constants";

const VERSION = "v5";

const RtoVehInfoQuestionContainer = ({
    pageType,
    questions,
    cmsImageGallery,
    isWebview,
    fetchRtoQuestionsConnect,
    saveRtoQuestionConnect
}) => {
    const { challenge = [] } = cmsImageGallery || {};
    const { tokens } = useTokens();
    const [isOpen, setIsOpen] = useState(false);
    const [askQuestions, setAskQuestions] = useState(false);

    const onOpen = () => {
        setIsOpen(true);
    };

    const openQuestions = async () => {
        await yieldToMain();
        onOpen();
        fetchRtoQuestionsConnect(VERSION).then(() => {
            window.setTimeout(() => {
                setAskQuestions(true);
                setIsOpen(false);
            }, NUMBER.THOUSAND);
        }).finally(() => {
            sendCustomGaEvents({
                event: "rto_accept_challenge_clicked",
                eventCategory: "rto_accept_challenge_clicked",
                eventAction: "Accept Challenge clicked"
            });
        });
    };

    const handleQuestionClose = () => {
        setAskQuestions(false);
        setIsOpen(false);
    };

    if ((challenge || []).length === NUMBER.ZERO) return null;

    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: ThinkingCap,
        animType: "svg",
        renderer: "svg",
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice"
        }
    };

    return (
        <div styleName={`styles.rtoChallenge ${isWebview && pageType === PAGE_TYPES.HOME ? "styles.rtoChallengePb" : ""}`}>
            <div styleName={"styles.challengeImg"} className="shrinkOnTouch">
                <LazyImage src={challenge[0].image} alt="rto-challenge" onClick={openQuestions} />
            </div>
            {
                askQuestions && !!(questions || []).length && <Modal isOpen={true}>
                    <RtoVehInfoQuestionList handleClose={handleQuestionClose} version={VERSION} saveRtoQuestionConnect={saveRtoQuestionConnect} />
                </Modal>
            }
            {
                isOpen &&
                <PopupModal
                    showCloseButton={false}
                    isOpen={isOpen}
                    onClose={() => { handleQuestionClose(); }}
                    overlayColor={tokens.background_surface_overlay_primary}
                    width="320px"
                    height="350px"
                >
                    <div styleName={"styles.rtoVehInfoQuestionPopup"}>
                        <Lottie width={130} height={130} options={{ defaultOptions, animationData: ThinkingCap }} />
                        <Heading level={NUMBER.FOUR}>Put on your thinking cap</Heading>
                        <div styleName={"styles.questionPopupText"}>
                            <BodyText color={tokens.text_default_text_secondary} level={NUMBER.TWO}>See how high you can score on the ultimate knowledge challenge!</BodyText>
                            {/* <div styleName="styles.adsContainerInPage">
                                <AdsComponent
                                    platformType="MOBILE"
                                    url={`${appUrl()}/rto-vehicle-registration-details/`}
                                    slotName= "cars24_rto_traffic_quiz_320x100"
                                    bu = "rto"
                                    expand = "YES"
                                    width = {320}
                                    height = {100}
                                />
                            </div> */}
                        </div>

                    </div>
                </PopupModal>
            }
        </div>
    );
};

RtoVehInfoQuestionContainer.propTypes = {
    questions: PropTypes.array,
    cmsImageGallery: PropTypes.object,
    fetchRtoQuestionsConnect: PropTypes.func,
    saveRtoQuestionConnect: PropTypes.func,
    isWebview: PropTypes.bool,
    pageType: PropTypes.string
};

export default RtoVehInfoQuestionContainer;
